import { ComponentMap } from '@cinch-nx/data-storyblok'
import {
  CarsCarousel,
  FinanceOffersCarouselBlock,
  GridRows,
} from '../molecule-blocks'
import { atomStoryblokComponents } from './atom-storyblok-components-map'

const moleculeStoryblokComponents: ComponentMap = {
  CarsCarousel,
  GridRows,
  FinanceOffersCarousel: FinanceOffersCarouselBlock,
}

export const sharedStoryblokComponents: ComponentMap = {
  ...atomStoryblokComponents,
  ...moleculeStoryblokComponents,
}
